import { render, staticRenderFns } from "./ComparteGana.vue?vue&type=template&id=97665eda&scoped=true"
import script from "./ComparteGana.vue?vue&type=script&lang=js"
export * from "./ComparteGana.vue?vue&type=script&lang=js"
import style0 from "./ComparteGana.vue?vue&type=style&index=0&id=97665eda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97665eda",
  null
  
)

export default component.exports